"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectedAudience = void 0;
var _react = require("react");
var _SelectedAudience = require("./SelectedAudience.styles");
var _ExpandableList = require("../../../../../Data/ExpandableList");
var _Chip = require("../../../../../UI/Chip");
var _hooks = require("../../../../../hooks");
var _Tooltip = require("../../../../../UI/Tooltip");
var _StudentsListItem = require("../AudienceSelectList/partials/AudienceList/partials/StudentsListItem");
var _AudiencePickerProvider = require("../../../provider/AudiencePickerProvider.helpers");
var _AudiencePicker = require("../../../AudiencePicker.helpers");
var _jsxRuntime = require("react/jsx-runtime");
const SelectedAudience = props => {
  const {
    originalSelectedClassesIds = [],
    originalSelectedGroupsIds = [],
    originalSelectedStudentsIds = [],
    selectedClassesIds,
    selectedGroupsIds,
    selectedStudentsIds,
    classesMapper,
    groupsMapper,
    studentsMapper,
    onDisableItemClick,
    onDeleteItem,
    onSelectedChanged,
    isReadOnly,
    readOnlyGroupsMapper,
    readOnlyStudentsMapper,
    cantRemoveMessage,
    setCantRemoveMessage
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const [items, setItems] = (0, _react.useState)([]);
  const styles = (0, _SelectedAudience.useStyles)(props);
  const handleRemoveAllItems = () => {
    if (onDeleteItem && (!(0, _AudiencePicker.checkSubset)(selectedClassesIds ?? [], originalSelectedClassesIds) || !(0, _AudiencePicker.checkSubset)(selectedGroupsIds ?? [], originalSelectedGroupsIds) || !(0, _AudiencePicker.checkSubset)(selectedStudentsIds ?? [], originalSelectedStudentsIds))) {
      setCantRemoveMessage(onDeleteItem());
    }
    onSelectedChanged({
      selectedGroupsIds: selectedGroupsIds?.filter(id => readOnlyGroupsMapper[id]) || [],
      selectedClassesIds: selectedClassesIds?.filter(id => readOnlyGroupsMapper[id]) || [],
      selectedStudentsIds: selectedStudentsIds?.filter(id => readOnlyStudentsMapper[id]) || []
    });
  };
  const handleDisabledItemClick = (0, _react.useCallback)(() => {
    if (onDisableItemClick) {
      setCantRemoveMessage(onDisableItemClick());
    }
  }, [onDisableItemClick, setCantRemoveMessage]);
  const handleDeleteItem = (0, _react.useCallback)((currentAudience, originalAudience) => {
    if (onDeleteItem && !(0, _AudiencePicker.checkSubset)(currentAudience, originalAudience)) {
      setCantRemoveMessage(onDeleteItem());
    }
  }, [onDeleteItem, setCantRemoveMessage]);
  (0, _react.useEffect)(() => {
    const basicChip = {
      color: 'basic',
      size: 'small',
      isSelected: true,
      id: '',
      label: ''
    };
    let _items = [];
    const handleClassRemove = id => {
      const selectedClassesIdsAfterRemove = selectedClassesIds?.filter(_id => _id !== id) ?? [];
      handleDeleteItem(selectedClassesIdsAfterRemove, originalSelectedClassesIds);
      onSelectedChanged({
        selectedGroupsIds,
        selectedStudentsIds,
        selectedClassesIds: selectedClassesIdsAfterRemove
      });
    };
    const handleGroupRemove = id => {
      const selectedGroupsIdsAfterRemove = selectedGroupsIds?.filter(_id => _id !== id) ?? [];
      handleDeleteItem(selectedGroupsIdsAfterRemove, originalSelectedGroupsIds);
      onSelectedChanged({
        selectedClassesIds,
        selectedStudentsIds,
        selectedGroupsIds: selectedGroupsIdsAfterRemove
      });
    };
    const handleStudentRemove = id => {
      const selectedStudentsIdsAfterRemove = selectedStudentsIds?.filter(_id => _id !== id) ?? [];
      handleDeleteItem(selectedStudentsIdsAfterRemove, originalSelectedStudentsIds);
      onSelectedChanged({
        selectedClassesIds,
        selectedGroupsIds,
        selectedStudentsIds: selectedStudentsIdsAfterRemove
      });
    };
    selectedClassesIds?.forEach(id => {
      if (classesMapper && classesMapper[id]) {
        const isDisabled = isReadOnly || readOnlyGroupsMapper[id];
        _items.push({
          position: 'bottom',
          anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.Chip, {
            ...basicChip,
            icon: isDisabled ? null : 'Close',
            id: id,
            label: classesMapper[id].group.name,
            isDisabled: isDisabled,
            onClick: isDisabled ? handleDisabledItemClick : undefined,
            onIconClick: () => {
              handleClassRemove(id);
            }
          }),
          children: null
        });
      }
    });
    selectedGroupsIds?.forEach(id => {
      if (groupsMapper && groupsMapper[id]) {
        const isDisabled = isReadOnly || readOnlyGroupsMapper[id];
        _items.push({
          position: 'bottom',
          anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.Chip, {
            ...basicChip,
            icon: isDisabled ? null : 'Close',
            id: id,
            label: groupsMapper[id].group.name,
            isDisabled: isDisabled,
            onClick: isDisabled ? handleDisabledItemClick : undefined,
            onIconClick: () => {
              handleGroupRemove(id);
            }
          }),
          children: null
        });
      }
    });
    selectedStudentsIds?.forEach(id => {
      if (studentsMapper && studentsMapper[id]) {
        const isDisabled = isReadOnly || readOnlyStudentsMapper[id];
        _items.push({
          position: 'bottom',
          anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.Chip, {
            ...basicChip,
            icon: isDisabled ? null : 'Close',
            id: id,
            label: (0, _AudiencePickerProvider.getStudentFullName)(studentsMapper[id].student),
            isDisabled: isDisabled,
            onClick: isDisabled ? handleDisabledItemClick : undefined,
            onIconClick: () => {
              handleStudentRemove(id);
            }
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StudentsListItem.StudentsListItem, {
            ...props,
            id: id,
            fullName: (0, _AudiencePickerProvider.getStudentFullName)(studentsMapper[id].student),
            isTooltip: true
          })
        });
      }
    });
    setItems(_items);
  }, [classesMapper, groupsMapper, handleDisabledItemClick, isMobileView, isReadOnly, onDisableItemClick, onDeleteItem, onSelectedChanged, originalSelectedClassesIds, originalSelectedGroupsIds, originalSelectedStudentsIds, props, readOnlyGroupsMapper, readOnlyStudentsMapper, selectedClassesIds, selectedGroupsIds, selectedStudentsIds, studentsMapper, handleDeleteItem]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-AudiencePicker__selected-audience'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandableList.ExpandableList, {
      ItemTag: _Tooltip.Tooltip,
      items: items,
      itemHeight: 36,
      isWithRemoveAllButton: isMobileView && !isReadOnly,
      onRemoveAllItems: handleRemoveAllItems
    }), cantRemoveMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-AudiencePicker__cannot-remove-message'],
      dangerouslySetInnerHTML: {
        __html: cantRemoveMessage
      }
    })]
  });
};
exports.SelectedAudience = SelectedAudience;